import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';

import { IPageProps } from '@folx-types/flow-steps';

import GetCare, { IGetCarePageContent } from './GetCare.component';

interface IGetCarePageProps extends IPageProps {}

const GetCarePage: FC<IGetCarePageProps> = ({ path }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "mssp-get-care-page" }) {
				heading
				description
				gender_affirming_care_label
				sexual_and_reproductive_health_label
				wellness_and_preventative_care_label
				feeling_ill_label
				mental_health_label
				fertility_and_family_planning_label
				disclaimer_fineprint
				inactive_tooltip
				tooltips {
					topic_id
					text
				}
				state_tooltips {
					state_id
					text
				}
				state_topic_tooltips {
					state_id
					topic_id
					text
				}
			}
		}
	`);

	const refinedContent: IGetCarePageContent = keysToCamel(pageContent) as IGetCarePageContent;

	return <GetCare pageContent={refinedContent} path={path} />;
};

export default GetCarePage;
